import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import HomeIcon from '@mui/icons-material/Home'
import {
  WEBSITE_VIEW_TYPES
} from 'src/consumer/constants'
import { LocalizationContext } from 'src/consumer/context/LocalizationContext'
import ProfessionalsListPage from '../Professionals List Page'
import {
  MySessionsBackground,
  SecondarySisterContainer
} from './MyLiveSessionStyles'
import {
  bookedPageViewTypes,
  prefixedLinkForNavigates
} from './my-live-sessions-utils'
import styled from 'styled-components'

const ModernHeader = styled.div`
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 24px 20px;
  margin: 0 -10px 40px -10px;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.15);
  position: relative;
  
  @media (min-width: 800px) {
    margin: 0 -50px 50px -50px;
    padding: 32px 50px;
    border-radius: 0 0 32px 32px;
  }
`

const NavigationBar = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`

const NavButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: Outfit, sans-serif;
  
  &:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  svg {
    font-size: 18px;
  }
  
  @media (min-width: 768px) {
    padding: 12px 20px;
    font-size: 15px;
    
    svg {
      font-size: 20px;
    }
  }
`

const PageTitle = styled.h1`
  color: #ffffff;
  font-size: 28px;
  font-weight: 700;
  margin: 0;
  font-family: Outfit, sans-serif;
  letter-spacing: -0.5px;
  line-height: 1.2;
  
  @media (min-width: 768px) {
    font-size: 36px;
  }
  
  @media (min-width: 1024px) {
    font-size: 42px;
  }
`

const PageSubtitle = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  font-weight: 400;
  margin: 8px 0 0 0;
  font-family: Outfit, sans-serif;
  line-height: 1.5;
  
  @media (min-width: 768px) {
    font-size: 18px;
    margin-top: 12px;
  }
`

export default function BookANewSessionPage({
  openedAsWebview,
  propSetupData: passedSetupData,
  propOneOnOneMentorsData,
}) {
  const navigate = useNavigate()

  if (sessionStorage.getItem('isThisWebviewSession') || openedAsWebview) {
    sessionStorage.setItem('notificationsAreDenied', true)
    sessionStorage.setItem('isThisWebviewSession', true)
  }

  const { localizedData } = useContext(LocalizationContext)
  const myLiveSessionsStrings = localizedData?.strings?.myLiveSessionsPage

  const websiteViewType =
    sessionStorage.getItem('isThisWebviewSession') || openedAsWebview
      ? WEBSITE_VIEW_TYPES.webview
      : WEBSITE_VIEW_TYPES.default

  function goToBookedSessions() {
    navigate(
      `${prefixedLinkForNavigates?.[websiteViewType]}/${bookedPageViewTypes?.booked_sessions}`,
    )
  }

  return (
    <MySessionsBackground>
      <SecondarySisterContainer>
        <ModernHeader>
          <NavigationBar>
            {websiteViewType === WEBSITE_VIEW_TYPES.default && (
              <NavButton onClick={() => navigate('/')}>
                <HomeIcon />
                {myLiveSessionsStrings?.home || 'Home'}
              </NavButton>
            )}
            <NavButton onClick={goToBookedSessions}>
              <CalendarTodayIcon />
              {myLiveSessionsStrings?.your_booked_sessions || 'Your Booked Sessions'}
            </NavButton>
          </NavigationBar>
          <PageTitle>
            {myLiveSessionsStrings?.book_a_new_session || 'Book a New Session'}
          </PageTitle>
          <PageSubtitle>
            Choose from our expert professionals and schedule your session
          </PageSubtitle>
        </ModernHeader>
        <ProfessionalsListPage
          setupData={passedSetupData}
          oneOnOneMentorsData={propOneOnOneMentorsData}
        />
      </SecondarySisterContainer>
    </MySessionsBackground>
  )
}
